import React, { useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from '../../styles/Dashboard.module.css';
import TableView from './TableView';
import { DashboardContext } from '../../store/dashboard-context';
import Spinner from '../../components/UI/Spinner';
import Pagination from '../../components/Pagination/Pagination';
import { PaginationContext } from '../../store/pagination-context';
import DashboardFilters from './DashboardFilters';

const Dashboard = () => {

    const dashboardCtx = useContext(DashboardContext);
    const paginationCtx = useContext(PaginationContext);

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const newPaginationParams = new URLSearchParams(paginationCtx.queryString);
        const newSearchParams = new URLSearchParams(searchParams);
        for (const [key, value] of newPaginationParams.entries()) {
            newSearchParams.set(key, value);
        }
        setSearchParams(newSearchParams);
    }, [paginationCtx.currentPage])

    return (
        <>
            <DashboardFilters />
            {dashboardCtx.isLoading ?
                <div className="d-flex justify-content-center align-items-center" style={{ 'height': '55vh' }}>
                    <Spinner size="md" />
                </div>
                : (
                    <div className="container bodyContainer">
                        <div className={`${styles.overviewScoreContainer}`}>
                            <div className={`${styles.tickets} card hover-effect`}>
                                <div className={`${styles.counts}`}>
                                    {dashboardCtx.total_tickets.toLocaleString()}
                                </div>
                                <div className={`${styles.label}`}>
                                    Total Tickets
                                </div>
                            </div>
                            <div className={`${styles.tickets} card hover-effect`}>
                                <div className={`${styles.counts}`}>
                                    {Math.round(parseFloat(dashboardCtx.review_score_avg))}%
                                </div>
                                <div className={`${styles.label}`}>
                                    Average QA Score
                                </div>
                            </div>
                        </div>
                        <div className='tableContainer mt-5'>
                            <TableView data={dashboardCtx.tickets} />
                        </div>
                        <Pagination totalCount={dashboardCtx.total_tickets} />
                    </div>
                )
            }

        </>
    )
}

export default Dashboard
